import {GET_GROUP_NEWS_START} from "../../types";

export const group_news = (payload) => ({
  type: GET_GROUP_NEWS_START,
  payload,
});
